/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * FIX credential creation request
 */
export interface FixCredentialCreationRequest {
  compId: string;
  accountId: number;
  username?: string;
  password?: string;
  comment?: string;
  talos: boolean;
}
